import { Component } from '@theme/component';

/**
 * Quote-only product gallery (sections/dc-quote-product.liquid): a thumbnail swaps the main
 * photo (src, srcset, alt) and marks itself pressed.
 *
 * @typedef {{ main?: HTMLImageElement, thumbs: HTMLButtonElement[] }} Refs
 * @extends {Component<Refs>}
 */
class DcQuoteGallery extends Component {
  /** @param {Event} event */
  show(event) {
    const thumb = event.target instanceof Element ? event.target.closest('button') : null;
    const { main, thumbs } = this.refs;
    if (!thumb || !main) return;
    main.srcset = thumb.dataset.srcset ?? '';
    main.src = thumb.dataset.src ?? main.src;
    main.alt = thumb.dataset.alt ?? '';
    for (const t of thumbs) t.setAttribute('aria-pressed', String(t === thumb));
  }
}

if (!customElements.get('dc-quote-gallery')) {
  customElements.define('dc-quote-gallery', DcQuoteGallery);
}
